<template>
  <v-layout column>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.firstName"
        :label="(isAdminLocalization ? adminText('adminAll.first_name_7e568a', 'First name') : $t('firstName', 'First name'))"
        :validator="$v.form.firstName"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.lastName"
        :label="(isAdminLocalization ? adminText('adminAll.last_name_adec36', 'Last name') : $t('lastName', 'Last name'))"
        :validator="$v.form.lastName"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.email"
        :label="(isAdminLocalization ? adminText('adminAll.email_84add5', 'Email') : $t('email', 'Email'))"
        type="email"
        :validator="$v.form.email"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.confirmEmail"
        :label="(isAdminLocalization ? adminText('adminAll.confirm_email_806e0e', 'Confirm Email') : $t('confirmEmail', 'Confirm Email'))"
        :validator="$v.form.confirmEmail"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.password"
        :label="(isAdminLocalization ? adminText('adminAll.password_8be3c9', 'Password') : $t('password', 'Password'))"
        :validator="$v.form.password"
        :type="showPasswordInput ? 'text' : 'password'"
        :append-icon="showPasswordInput ? 'visibility_off' : 'visibility'"
        @clickAppendIcon="showPasswordInput = !showPasswordInput"
      />
    </v-flex>
    <v-flex class="pb-16">
      <slot name="submit-button" :submit="submitForm" />
    </v-flex>
  </v-layout>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
import { email, minLength, required, sameAs } from 'vuelidate/lib/validators'

export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'sign-up-form',
  data() {
    return {
      showPasswordInput: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        confirmEmail: '',
        password: '',
      },
    }
  },
  validations() {
    return {
      form: {
        firstName: { required },
        lastName: { required },
        email: { required, email },
        confirmEmail: { required, email, sameAsEmail: sameAs('email') },
        password: { required, minLength: minLength(5) },
      },
    }
  },
  methods: {
    submitForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      // Remove the confirmEmail field from form before emitting
      const formData = { ...this.form }
      delete formData.confirmEmail
      this.$emit('submit', formData)
    },
  },
}
</script>
